/** Modos de envio dos boletos para os clientes */
export interface ClienteModoEnvioBoleto {
    id: number;
    nome: string;
}

export const modoEnvioBoletoEmail: ClienteModoEnvioBoleto = {
    id: 1,
    nome: 'E-mail'
};

export const modoEnvioBoletoViasNormais: ClienteModoEnvioBoleto = {
    id: 2,
    nome: 'Vias Normais'
};

export const modosEnviosBoletos: ClienteModoEnvioBoleto[] = [
    modoEnvioBoletoEmail,
    modoEnvioBoletoViasNormais
];

/** Verifica se o modo de envio de boletos para os clientes é por e-mail */
export function isModoEnvioBoletoEmail(modoEnvioBoleto: number): boolean {
    return modoEnvioBoleto === modoEnvioBoletoEmail.id;
}

/** Verifica se o modo de envio de boletos para os clientes é por vias normais */
export function isModoEnvioBoletoViasNormais(modoEnvioBoleto: number): boolean {
    return modoEnvioBoleto === modoEnvioBoletoViasNormais.id;
}
